import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'
import { color } from "../../../WEBContent/Color";
import { icon } from '../../../WEBContent/Icon';
import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const doc_type = useRef(null);

    const type_active = useRef(null);
    const types_actives = useRef(null);
    const dados_actives = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [lang, set_lang] = useState('pt');
    const { pathname } = useLocation()

    const handleRowClick = (id) => {
        document.getElementById('c_' + id)?.click();
    };

    const get_info = async () => {

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (Array.isArray(res.data)) {
                    setData(res.data)

                    console.log('res.data', res.data)
                }
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            console.log('1111')
            await get_info()
            console.log('2222')

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_type = (id) => {

        if (id !== '') {

            let aux = doc_type.current.filter(e => parseInt(e.id) === parseInt(id))

            return aux[0].info.name
        }
        else {
            return ''
        }

    }

    const change_type = (id) => {

        set_dados(type_active.current = id)
        let aux = data.filter(e => parseInt(e.info.settings.doc_type) === parseInt(id))
        set_dados(dados_actives.current = aux)

    }

    const columns = [
        {
            id: 'name',
            name: language[lang].field_name,
            selector: 'info.name',
            width: '20% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info.name}
                </Link>
            ),
        },
        {
            id: 'amount',
            name: language[lang].amount,
            selector: row => row.info.amount,
            width: '7% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{
                        pathname: endpoints.view,
                        state: { item: row, operation: 'view' }
                    }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    € {row.info.amount}
                </Link>
            ),
        },
        {
            id: 'createdBy',
            name: language[lang].createdBy,
            selector: 'info.responsable.create.name',
            width: '12% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info.responsable.create.name}
                </Link>
            ),
        },
        {
            id: 'last_update',
            name: language[lang].table_date,
            selector: 'info.responsable.create.execution',
            width: '12% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
            cell: (row) => {
                const execution = row.info?.responsable?.update?.execution
                    ?? row.info?.edition_archive?.[0]?.responsables?.update?.execution
                    ?? row.info?.responsable?.create?.execution;

                const formatDate = (value) => {
                    if (!value) return '';
                    const date = new Date(value);
                    const dd = String(date.getDate()).padStart(2, '0');
                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                    const yyyy = date.getFullYear();
                    const hh = String(date.getHours()).padStart(2, '0');
                    const min = String(date.getMinutes()).padStart(2, '0');
                    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
                };

                return (
                    <Link
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        {formatDate(execution)}
                    </Link>
                );
            },
        },
        {
            id: 'stage',
            name: language[lang].stage,
            selector: 'info.stage.label',
            width: '7% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{
                        textDecoration: 'none',
                        color: row.info?.stage?.color ?? '#555555',
                        fontWeight: 'bold'
                    }}
                >
                    {row.info?.stage?.label ?? ''}
                </Link>
            ),
        },
        {
            id: 'company',
            name: language[lang].company,
            selector: 'info.contacts.company.name',
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info.contacts.company.name}
                </Link>
            ),
        },
        {
            id: 'point_of_contact',
            name: language[lang].point_of_contact,
            selector: 'info.contacts.point_of_contact',
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info.contacts.point_of_contact}
                </Link>
            ),
        },
        {
            id: 'btn',
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '10px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8">
                                        {permissions.current !== null && (permissions.current.create) && (
                                            <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                to={{ pathname: endpoints.regist }}
                                                style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                            >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        )}
                                    </div>

                                    <div className="table-body">
                                        <div className="row">
                                            <div className="col-12 mb-3 d-flex">
                                                {
                                                    types_actives.current !== undefined && types_actives.current !== null ?
                                                        types_actives.current.map((dt_el, dt_key) => {
                                                            return (
                                                                <div key={dt_key}>
                                                                    <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el.id) === parseInt(type_active.current) ? ' active' : '')} onClick={() => change_type(dt_el.id)} >{dt_el.info.name}</button>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>

                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                defaultSortAsc={true}
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                onRowClicked={(row) => handleRowClick(row.id)}
                                                customStyles={{
                                                    rows: {
                                                        style: {
                                                            cursor: 'pointer',
                                                            minHeight: '24px',
                                                        },
                                                    },
                                                    headCells: {
                                                        style: {
                                                            padding: '2px',
                                                            fontSize: '12px',
                                                            //color:'red',

                                                        },
                                                    },
                                                    cells: {
                                                        style: {
                                                            //color:'red',
                                                            padding: '2px',
                                                            fontSize: '12px',
                                                        },
                                                    },
                                                }}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}